<template>
  <fts-modal
    width="425px"
    :footer="false"
    header-class="form-message-modal__header"
    content-class="form-message-modal__body"
    class="fts-form-message-modal"
    @close="close"
    v-if="showDialog"
  >
    <template #header>
      <fts-btn text icon class="form-message-header-close" @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </template>
    <template #body>
      <div class="form-message-icon">
        <font-awesome-icon :icon="['far', 'check-circle']" />
      </div>

      <div class="form-message-title">
        Success
      </div>

      <div class="form-message-content">
        {{content}}
      </div>

      <fts-btn color="success" outline @click="close">
        Continue
      </fts-btn>
    </template>
  </fts-modal>
</template>

<script>
import FTSBtn from '../FTSBtn';
import FTSModal from '../FTSModal';

export default {
  components: {
    'fts-btn': FTSBtn,
    'fts-modal': FTSModal
  },
  data: () => ({
    showDialog: false,
    resolve: null,
    content: null
  }),
  methods: {
    async show(content) {
      this.content = content;
      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.showDialog = true;
      });
    },
    close() {
      this.showDialog = false;
      this.resolve && this.resolve(true);
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
}
</script>

<style lang="scss">
.fts-form-message-modal {
  .form-message-modal__header {
    position: relative;
    padding: 1.5rem;
  }
  .form-message-modal__body {
    position: relative;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 1.5rem;
    text-align: center;
  }
  .form-message-header-close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
  }
  .form-message-btn-close {
    margin-left: 0.75rem;
    margin-top: -1rem;
    margin-right: -1rem;
  }
  .form-message-icon {
    margin-bottom: 1rem;
    font-size: 3rem;
    color: var(--fts-success);
  }
  .form-message-title {
    margin-bottom: 0.5rem;
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.75rem;
    color: var(--fts-text);
  }
  .form-message-content {
    margin-bottom: 2.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--fts-text);
  }
}
</style>